import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const L10UM = styled.p`
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.08em;
  ${customTextColor}
`;
